import { EventApiClass } from 'src/api/EventApi';
import { MockEventAdapter } from 'src/adapter/mock/MockEventAdapter';
const EventApi = new EventApiClass(new MockEventAdapter());
import { IncidentApiClass } from 'src/api/IncidentApi';
import { MockIncidentAdapter } from 'src/adapter/mock/MockIncidentAdapter';
const IncidentApi = new IncidentApiClass(new MockIncidentAdapter());
import { EnqueteApiClass } from 'src/api/EnqueteApi';
/*
import { MockEnqueteAdapter } from 'src/adapter/mock/MockEnqueteAdapter';
const EnqueteApi = new EnqueteApiClass(new MockEnqueteAdapter());
*/
import { AxiosEnqueteAdapter } from 'src/adapter/axios/AxiosEnqueteAdapter';
const EnqueteApi = new EnqueteApiClass(new AxiosEnqueteAdapter());
import { EnqueteTemplateApiClass } from 'src/api/EnqueteTemplateApi';
import { AxiosEnqueteTemplateAdapter } from 'src/adapter/axios/AxiosEnqueteTemplateAdapter';
const EnqueteTemplateApi = new EnqueteTemplateApiClass(
  new AxiosEnqueteTemplateAdapter()
);

import { QuestionTemplateApiClass } from 'src/api/QuestionTemplateApi';
import { AxiosQuestionTemplateAdapter } from 'src/adapter/axios/AxiosQuestionTemplateAdapter';
const QuestionTemplateApi = new QuestionTemplateApiClass(
  new AxiosQuestionTemplateAdapter()
);

import { QuestionCategoryApiClass } from 'src/api/QuestionCategoryApi';
import { AxiosQuestionCategoryAdapter } from 'src/adapter/axios/AxiosQuestionCategoryAdapter';
const QuestionCategoryApi = new QuestionCategoryApiClass(
  new AxiosQuestionCategoryAdapter()
);

import { StartSettingApiClass } from 'src/api/StartSettingApi';
import { AxiosStartSettingAdapter } from 'src/adapter/axios/AxiosStartSettingAdapter';
const StartSettingApi = new StartSettingApiClass(
  new AxiosStartSettingAdapter()
);

// Account
import { AccountApiClass } from 'src/api/AccountApi';
import { SessionStorageAccountAdapter } from 'src/adapter/session/SessionStorageAccountAdapter';
import { AxiosAccountAdapter } from 'src/adapter/axios/AxiosAccountAdapter';
let AccountApi: AccountApiClass;
if (process.env.ACCOUNT_ADAPTER == 'axios') {
  AccountApi = new AccountApiClass(new AxiosAccountAdapter());
} else {
  AccountApi = new AccountApiClass(new SessionStorageAccountAdapter());
}

// MailTemplate
import { MailTemplateApiClass } from 'src/api/MailTemplateApi';
import { MockMailTemplateAdapter } from 'src/adapter/mock/MockMailTemplateAdapter';
import { AxiosMailTemplateAdapter } from 'src/adapter/axios/AxiosMailTemplateAdapter';
let MailTemplateApi: MailTemplateApiClass;
if (process.env.MAIL_TEMPLATE_ADAPTER == 'axios') {
  MailTemplateApi = new MailTemplateApiClass(new AxiosMailTemplateAdapter());
} else {
  MailTemplateApi = new MailTemplateApiClass(new MockMailTemplateAdapter());
}

// Group
import { GroupApiClass } from 'src/api/GroupApi';
import { AxiosGroupAdapter } from 'src/adapter/axios/AxiosGroupAdapter';
const GroupApi = new GroupApiClass(new AxiosGroupAdapter());
// GroupType
import { GroupTypeApiClass } from 'src/api/GroupTypeApi';
import { SessionStorageGroupTypeAdapter } from 'src/adapter/session/SessionStorageGroupTypeAdapter';
import { AxiosGroupTypeAdapter } from 'src/adapter/axios/AxiosGroupTypeAdapter';
let GroupTypeApi: GroupTypeApiClass;
if (process.env.GROUP_TYPE_ADAPTER == 'axios') {
  GroupTypeApi = new GroupTypeApiClass(new AxiosGroupTypeAdapter());
} else {
  GroupTypeApi = new GroupTypeApiClass(new SessionStorageGroupTypeAdapter());
}
// ResourceType
import { ResourceTypeApiClass } from 'src/api/ResourceTypeApi';
import { AxiosResourceTypeAdapter } from 'src/adapter/axios/AxiosResourceTypeAdapter';
const ResourceTypeApi = new ResourceTypeApiClass(
  new AxiosResourceTypeAdapter()
);
// Resource
import { ResourceApiClass } from 'src/api/ResourceApi';
import { AxiosResourceAdapter } from 'src/adapter/axios/AxiosResourceAdapter';
const ResourceApi = new ResourceApiClass(new AxiosResourceAdapter());
// GroupResource
import { GroupResourceApiClass } from 'src/api/GroupResourceApi';
import { AxiosGroupResourceAdapter } from 'src/adapter/axios/AxiosGroupResourceAdapter';
const GroupResourceApi = new GroupResourceApiClass(
  new AxiosGroupResourceAdapter()
);
// Address
import { AddressApiClass } from 'src/api/AddressApi';
import { AxiosAddressAdapter } from 'src/adapter/axios/AxiosAddressAdapter';
const AddressApi = new AddressApiClass(new AxiosAddressAdapter());
// TargetResource
import { TargetResourceApiClass } from 'src/api/TargetResourceApi';
import { MockTargetResourceAdapter } from 'src/adapter/mock/MockTargetResourceAdapter';
import { AxiosTargetResourceAdapter } from 'src/adapter/axios/AxiosTargetResourceAdapter';
const TargetResourceApi = new TargetResourceApiClass(
  //new MockTargetResourceAdapter()
  new AxiosTargetResourceAdapter()
);
// Bulk
import { BulkApiClass } from 'src/api/BulkApi';
//import { MockBulkAdapter } from 'src/adapter/mock/MockBulkAdapter';
import { AxiosBulkAdapter } from 'src/adapter/axios/AxiosBulkAdapter';
const BulkApi = new BulkApiClass(new AxiosBulkAdapter());
// Auth
import { AuthApiClass } from 'src/api/AuthApi';
//import { MockAuthAdapter } from 'src/adapter/mock/MockAuthAdapter';
import { AxiosAuthAdapter } from 'src/adapter/axios/AxiosAuthAdapter';
const AuthApi = new AuthApiClass(new AxiosAuthAdapter());
// Profile
import { ProfileApiClass } from 'src/api/ProfileApi';
import { AxiosProfileAdapter } from 'src/adapter/axios/AxiosProfileAdapter';
const ProfileApi = new ProfileApiClass(new AxiosProfileAdapter());
export {
  EventApi,
  IncidentApi,
  EnqueteApi,
  EnqueteTemplateApi,
  QuestionTemplateApi,
  MailTemplateApi,
  StartSettingApi,
  AccountApi,
  GroupApi,
  GroupTypeApi,
  ResourceTypeApi,
  ResourceApi,
  GroupResourceApi,
  QuestionCategoryApi,
  AddressApi,
  TargetResourceApi,
  BulkApi,
  AuthApi,
  ProfileApi,
};
